import { Editor } from 'slate';

import { slateToText } from './serialize';

export const isEntireVariationSelected = (editor) => {
  const context = getPlainTextSelectionContext(editor);
  const selection = getPlainTextSelection(editor);
  return context === selection;
};

const getSelectionEdgePoints = (editor) => {
  return Editor.edges(editor, editor.selection);
};

const getPlainTextSelection = (editor) => {
  if (!editor.selection) return '';

  const fragment = Editor.fragment(editor, editor.selection);
  return slateToText(fragment);
};

const getPlainTextSelectionContext = (editor) => {
  if (!editor.selection) return '';

  const [start, end] = getSelectionEdgePoints(editor);

  const fragment = Editor.fragment(editor, {
    anchor: Editor.point(editor, [start.path[0]], {
      edge: 'start',
    }),
    focus: Editor.point(editor, [end.path[0]], { edge: 'end' }),
  });
  return slateToText(fragment);
};
